import { visible } from "@escapio/shared/event/visibility-observer";
import { data } from "@escapio/shared/state/payload";
import { html, render } from "lit-html";
import { ProfileMapDialog } from "./ProfileMapDialog";
import "./map-libre/HotelMap";

let mapDialog = null;
export function showHotelMapDialog(event, origin) {
	event.preventDefault();
	event.stopPropagation();
	mapDialog = mapDialog || new ProfileMapDialog();
	mapDialog.show(origin);
}

customElements.define(
	"esc-static-hotel-map",
	class extends HTMLElement {
		connectedCallback() {
			visible(this, 100, 100).then(() => this.loadMapLibreMap());
		}

		loadMapLibreMap() {
			render(
				html`<esc-maplibre-hotel-map
					.primaryHotels=${[data.hotel]}
					@click=${this.onClick}
					static
				></esc-maplibre-hotel-map>`,
				this,
				{ host: this },
			);
		}

		onClick(event) {
			showHotelMapDialog(event, "Lage");
		}
	},
);
